.wrapperSelects,
.wrapperInputs {
    display: flex;
    flex-direction: column;
    margin-bottom: 32px;
    gap: 16px;

    @media (min-width:768px) {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}

.requestTypeSelect {
    margin: 32px 0;
}

.apiInput {
    margin-bottom: 32px;
}